import { render, staticRenderFns } from "./FormMintNftConfirm.vue?vue&type=template&id=aa704640&"
import script from "./FormMintNftConfirm.vue?vue&type=script&lang=js&"
export * from "./FormMintNftConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports